import {CurrentAgentCommissionDialog} from "app/pages/AgentPricing/modules/EditDialogs/state";
import {Action, ActionType} from 'app/pages/AgentPricing/actionTypes';

export function reducer(state: CurrentAgentCommissionDialog|undefined, action: Action) {
    if (state == undefined)
        state = CurrentAgentCommissionDialog.None;

    switch(action.type) {
        case ActionType.ChangeCurrentDialog:
            return action.dialog;
        case ActionType.ChangeSchoolOverrides:
            return CurrentAgentCommissionDialog.None;
        default: 
            return state;
    }
}